module.exports = __webpack_public_path__ + "static/images/challenge.bf4e42092f7fce4f6e0b25fb5a3f2ed0.png";